import MenuButton from '../components/MenuButton'
import { useGame } from '../contexts/GameContext'
import { assets } from '../utils/assets'
import { cn } from '../lib/utils'

export function HomeScreen() {
	const { currentScreen, changeScreen } = useGame()

	return (
		<div
			className={cn(
				'pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300',
				{
					'pointer-events-auto opacity-100': currentScreen === 'home',
				}
			)}
		>
			<div className="relative h-screen w-full overflow-hidden">
				<img src="./assets/telas/tela_inicial.ai.png" alt="Fundo" className="h-dvh w-dvw object-fill" />

				<div className="absolute right-[5%] bottom-[5%] grid place-items-center gap-2 lg:gap-4">
					<img src="./assets/turma-mk.png" className="h-8 lg:h-12" alt="Logo Micro Kids" />

					<MenuButton
						src="./assets/botoes/botao_iniciar.svg"
						alt="Iniciar"
						onClick={() => changeScreen('game')}
						title="Iniciar Jogo"
						className="h-12 lg:h-20"
					/>

					<MenuButton
						src="./assets/botoes/botao_instrucoes.svg"
						alt="Instruções"
						onClick={() => changeScreen('instructions')}
						title="Ver Instruções"
						className="h-12 lg:h-20"
					/>

					<MenuButton
						src="./assets/botoes/ranking.png"
						alt="Ranking"
						onClick={() => changeScreen('ranking')}
						title="Ver Ranking"
						className="h-12 lg:h-20"
					/>

					<img src="./assets/microkids.svg" className="h-8 scale-50 lg:scale-75" alt="Logo Micro Kids" />
				</div>
			</div>
		</div>
	)
}
